export default function calcCurrentDirection(queryDirection, directions, defaultDirection) {
  if (!queryDirection) {
    return defaultDirection;
  }

  const currentDirection = directions.reduce((acc, cur) => {
    return cur.slug === queryDirection ? cur : cur.children?.find((i) => i.slug === queryDirection) ? cur : acc;
  }, null);

  return currentDirection || defaultDirection;
}
